import Enums from '../Enum'
import i18n from '@/i18n'
export default new Enums({
  SOLD: {
    text: i18n._('全部'),
    value: 1, // 销售中
  },
  SOLD_OUT: {
    text: i18n._('上架'),
    value: 2, // 售罄
  },
  SOLD_WAITING: {
    text: i18n._('下架'),
    value: 3, // 待售
  },
})
